import { jsx } from "react/jsx-runtime";
import { c as clsx } from "../../../chunks/clsx-DF9QTL9H.js";
const underline = "_underline_8qz9h_13";
const heading = "_heading_8qz9h_17";
const text = "_text_8qz9h_1";
const price = "_price_8qz9h_219";
const styles = {
  "text-align-left": "_text-align-left_8qz9h_1",
  "text-align-center": "_text-align-center_8qz9h_5",
  "text-align-right": "_text-align-right_8qz9h_9",
  underline,
  heading,
  "heading-display": "_heading-display_8qz9h_22",
  "heading-largest": "_heading-largest_8qz9h_46",
  "heading-large": "_heading-large_8qz9h_46",
  "heading-medium": "_heading-medium_8qz9h_94",
  "heading-small": "_heading-small_8qz9h_118",
  "heading-smallest": "_heading-smallest_8qz9h_142",
  "heading-tiny": "_heading-tiny_8qz9h_166",
  text,
  "text-body": "_text-body_8qz9h_195",
  "text-body-head": "_text-body-head_8qz9h_201",
  "text-caption": "_text-caption_8qz9h_207",
  "text-caption-head": "_text-caption-head_8qz9h_213",
  price,
  "price-large": "_price-large_8qz9h_224",
  "price-large-discount": "_price-large-discount_8qz9h_230",
  "price-medium": "_price-medium_8qz9h_237",
  "price-medium-discount": "_price-medium-discount_8qz9h_243",
  "price-small": "_price-small_8qz9h_250",
  "price-small-discount": "_price-small-discount_8qz9h_256"
};
const deprecatedVariantsMap = {
  large: "heading-largest",
  medium: "heading-large",
  small: "heading-medium",
  smallest: "heading-small",
  subheading1: "heading-smallest",
  subheading2: "heading-tiny",
  body: "text-body",
  "body-head": "text-body-head",
  caption: "text-caption",
  "caption-head": "text-caption-head"
};
const classMap = {
  heading: styles.heading,
  text: styles.text,
  price: styles.price
};
const Text = ({
  component,
  align,
  underline: underline2,
  children,
  variant = "text-body",
  ...props
}) => {
  const Component = component || "p";
  let textStyleClasses;
  if (variant in deprecatedVariantsMap) {
    variant = deprecatedVariantsMap[variant];
  }
  const variantType = variant.split("-")[0];
  textStyleClasses = classMap[variantType] || "";
  const className = clsx(
    textStyleClasses,
    styles[align ? `text-align-${align}` : ""],
    styles[underline2 ? "underline" : ""],
    styles[variant],
    props.className
  );
  return /* @__PURE__ */ jsx(Component, { ...props, className, children });
};
const H1 = ({ variant = "heading-largest", ...props }) => /* @__PURE__ */ jsx(Text, { variant, component: "h1", ...props, children: props.children });
const H2 = ({ variant = "heading-large", ...props }) => /* @__PURE__ */ jsx(Text, { variant, component: "h2", ...props, children: props.children });
const H3 = ({ variant = "heading-medium", ...props }) => /* @__PURE__ */ jsx(Text, { variant, component: "h3", ...props, children: props.children });
const H4 = ({ variant = "heading-small", ...props }) => /* @__PURE__ */ jsx(Text, { variant, component: "h4", ...props, children: props.children });
const H5 = ({ variant = "heading-smallest", ...props }) => /* @__PURE__ */ jsx(Text, { variant, component: "h5", ...props, children: props.children });
const H6 = ({ variant = "heading-tiny", ...props }) => /* @__PURE__ */ jsx(Text, { variant, component: "h6", ...props, children: props.children });
const P = ({ variant = "text-body", ...props }) => /* @__PURE__ */ jsx(Text, { variant, component: "p", ...props, children: props.children });
const Strong = ({
  variant = "text-body-head",
  ...props
}) => /* @__PURE__ */ jsx(Text, { variant, component: "strong", ...props, children: props.children });
const Small = ({ variant = "text-caption", ...props }) => /* @__PURE__ */ jsx(Text, { variant, component: "small", ...props, children: props.children });
export {
  H1,
  H2,
  H3,
  H4,
  H5,
  H6,
  P,
  Small,
  Strong,
  Text,
  deprecatedVariantsMap
};
